module.exports = __webpack_public_path__ + "static/media/icon-refresh-suggested-rank.2d35080e.svg";